import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';

class ModalBody extends React.Component {

  constructor(props){
    super(props)
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
    } = this.props;

		return (
      <Modal
				className='attendance-modal'
				hasHeader={false}
        hasFooter={false}
        fixedWidth={460}
        contentHeight={350}
        onCloseModalClick={dismiss}
        isShowingModal={show} >
        <ModalContent {...this.props} />
			</Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/LessonEditColor/ModalBody.js